import React, { ComponentPropsWithoutRef } from "react";
import "./skip-nav.css";

interface Props
  extends Omit<ComponentPropsWithoutRef<"a">, "children" | "href" | "id"> {
  contentId: string;
  label?: string;
}

export function SkipNav({
  contentId,
  label = "Skip to content",
  ...rest
}: Props) {
  return (
    <a {...rest} id="skip-nav" href={`#${contentId}`}>
      {label}
    </a>
  );
}
